module.exports = __webpack_public_path__ + "static/media/knee-flexion.24486c72.svg";